import { render, staticRenderFns } from "./ReleaseOverviewManager.vue?vue&type=template&id=f89fe476&scoped=true&"
import script from "./ReleaseOverviewManager.vue?vue&type=script&lang=js&"
export * from "./ReleaseOverviewManager.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseOverviewManager.vue?vue&type=style&index=0&id=f89fe476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89fe476",
  null
  
)

export default component.exports